export const isReactPage = () => !!document.getElementById('react-root');
